import React from 'react';

import '@builder.io/widgets';
import { builder } from '@builder.io/react';
import { BUILDER_API_KEY } from 'src/scripts/utils/environment';
import BuilderReactComponent from '../../Builder/BuilderReactComponent';

// Init builder
// ? [REVISIT] Soon we should develop a way to ensure that we only init it once.
if (BUILDER_API_KEY) builder.init(BUILDER_API_KEY);

const LoyaltyBuilderFAQContent = () => {
  const userAgent = navigator.userAgent.toLowerCase().includes('aloios') ? 'aloios' : navigator.userAgent;
  let builderContent;
  if (BUILDER_API_KEY) {
    builderContent = <BuilderReactComponent model="web-component-page" userAgent={userAgent} />;
  }
  return <>{builderContent ?? null}</>;
};

export default LoyaltyBuilderFAQContent;
